import IconProps, { StyledG } from 'packages/kakapo-ui-kit/assets/icons/IconProps';

function CommentIcon({ color = '#000000' }: IconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 64 64">
			<StyledG
				transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
				color={color}
				stroke="none"
			>
				<path
					d="M143 620 c-51 -31 -63 -65 -63 -180 0 -167 31 -200 194 -200 l99 0
				68 -55 c37 -30 70 -55 73 -55 4 0 6 24 6 53 0 51 1 52 40 69 64 27 80 64 80
				188 0 87 -4 111 -20 137 -35 57 -58 63 -262 63 -164 0 -186 -2 -215 -20z m432
				-45 c24 -23 25 -31 25 -135 0 -104 -1 -112 -25 -135 -16 -17 -35 -25 -59 -25
				-33 0 -35 -2 -38 -40 l-3 -39 -52 39 -52 40 -101 0 c-94 0 -103 2 -125 25 -24
				23 -25 31 -25 135 0 104 1 112 25 135 24 25 26 25 215 25 189 0 191 0 215 -25z"
				/>
				<path
					d="M17 453 c-13 -25 -17 -56 -17 -135 0 -122 16 -160 80 -186 39 -17 40
				-18 40 -69 0 -29 2 -53 6 -53 3 0 36 25 73 55 61 49 73 55 115 55 39 0 46 3
				46 20 0 17 -7 20 -46 20 -37 0 -54 -7 -97 -40 l-52 -39 -3 39 c-3 38 -5 40
				-36 40 -19 0 -44 9 -57 19 -23 18 -24 27 -29 163 -5 143 -5 143 -23 111z"
				/>
			</StyledG>
		</svg>
	);
}

export default CommentIcon;
